import { Injectable } from '@angular/core';
import { BotService } from './bot.service';
import { EventManagerAdminService } from './event-manager/event-manager-admin.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
@Injectable({
  providedIn: 'root'
})
export class WebhookManagerService {
  constructor(
    private botService: BotService,
    private botIdService: BotidService,
    private eventManager: EventManagerAdminService
  ) {
  }

  public async call(skillId: string, request?: unknown) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.WEBHOOK.CALL.request', { skillId, request });
    const result = await this.botService.callWebhook(this.botIdService.getBotId(), skillId, request);
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.WEBHOOK.CALL.result', { skillId, request, result });
    return result;
  }
}
